import React from 'react';
import Typing from 'react-typing-animation';
import kamil from '../../media/pictures/kamil-intro3.png';
import '../TopBanner/TopBanner.css';

const TopBanner = () => {
    return (
        <div className="top-banner flex">
            <section className="my-auto relative text-center  mx-auto">
                <div className="mx-auto"><img className="w-32 mx-auto md:w-48 rounded-full border-8 border-blue-400" src={kamil}
                    alt="kamil hassan" />
                </div>

                <Typing>
                    <p className="text-white  text-center mt-4 text-xl text-space tracking-wide">Hi! I'm Kamil Hassan</p>
                </Typing>

            </section>

        </div>
    );
};

export default TopBanner;